import axios from './axiosWithDefaults';

const headers = {
  'Content-Type': 'application/json',
};

const csrfMetaTag = document.querySelector('meta[name="csrf-token"]');
if (csrfMetaTag) {
  headers['X-Csrf-Token'] = csrfMetaTag.content;
}

const api = axios.create({ headers });

// A FormData body must go out without the JSON Content-Type above so the browser sets multipart/form-data with its
// boundary. axios 0.21 dropped the header by itself; axios 1.x would serialize the FormData to a JSON string instead
// (files lost). Used by the user-report attachment and the admin login-info image.
api.interceptors.request.use((config) => {
  if (typeof FormData !== 'undefined' && config.data instanceof FormData) config.headers.setContentType(false);
  return config;
});

export default api;
